import classNames from 'classnames'
import Icon from 'components/Icon'
import PriceWithCurrency from 'components/PriceWithCurrency'
import { SiteCurrency } from 'components/PriceWithCurrency/PriceWithCurrency'
import { UI } from 'Icon/ui'
import * as React from 'react'
import { DefaultContent } from 'react-content-engine'
import './PricesDayCell.scss'

interface PricesDayCellProps {
  disabled?: (day: number) => boolean
  day?: number
  cheapestDays?: number[]
  showCheapest: boolean
  currency: SiteCurrency
  getPrice: (day: number) => number | undefined
  getPill?: (day: number) => string | JSX.Element | null
}

const PricesDayCell: React.FC<PricesDayCellProps> = ({
  disabled,
  day,
  showCheapest,
  currency,
  getPrice,
  getPill,
  cheapestDays,
}) => {
  const price = getPrice(day || 0) || 0
  const isDisabled = disabled ? disabled(day ? day : 0) : false
  const renderPill = getPill ? getPill(day ? day : 0) : null
  const cheapest = cheapestDays ? cheapestDays.includes(day ? day : 0) : false
  const className = classNames(
    'display-prices',
    isDisabled && 'is-disabled',
    cheapest && 'is-cheapest',
  )
  return (
    <div className={className}>
      {renderPill ? (
        <span className="date-availability">{renderPill}</span>
      ) : null}
      {cheapest && showCheapest ? (
        <p className="cheapest-day">
          <DefaultContent contentKey="day-cheapest-label">
            Lowest
          </DefaultContent>
        </p>
      ) : (
        <span className="date-day">{day}</span>
      )}
      {price !== 0 ? (
        <span className="date-price">
          <PriceWithCurrency
            currency={currency}
            price={price}
            short={currency === SiteCurrency.krona}
          />
        </span>
      ) : null}
      <Icon icon={UI.check} />
    </div>
  )
}

export default PricesDayCell
